import React, { Suspense, useEffect } from 'react';
import { ConfigProvider, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import LoginComponent from './components/login/Login';
import ForgotPassword from './components/login/ForgotPassword';
import ResetPassword from './components/login/ResetPassword';
import Dashboard from './components/layout/dashboard';
import './assets/styles/global.css';

const App = ({ tokenStore }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!tokenStore.value || `${tokenStore.value}`.trim() === '') {
      i18n.changeLanguage('en');
    }
  }, [tokenStore.value, i18n]);

  message.config({
    top: 100,
    duration: 2,
    maxCount: 3,
  });

  return (
    <Suspense fallback="loading...">
      <div className="main-wrapper">
        <ConfigProvider direction={i18n.language === 'en' ? 'ltr' : 'rtl'}>
          <Router>
            <Switch>
              <Route path="/login" component={LoginComponent} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/reset-password" component={ResetPassword} />
              <AuthGuard>
                <Route path="/" component={Dashboard} />
              </AuthGuard>
            </Switch>
          </Router>
        </ConfigProvider>
      </div>
    </Suspense>
  );
};

export default inject('tokenStore')(observer(App));
